import React, { useState, useEffect } from 'react';
import QuoteCards from './QuoteCards'
import { connect } from 'react-redux';
import { getQuo } from '../Actions/Quote_actions';
import styled, { keyframes } from 'styled-components'
const dimmer = keyframes`
from {
    opacity: 0;
}

to {
    opacity: 1;
    
}
`
const PUSHCARDMOBILE = styled.section`
@media screen and (max-width: 48rem) {
    transition: 3s ease-in-out;
    position: fixed;
    background: transparent;
    width: 90%;
    padding: 0rem;
    margin: 0;
    top: 6%;
    animation ${dimmer} 2s;
    z-index: 20;
}
@media screen and (min-width: 48rem) {
    display: none;
}
`
const PUSHCARDDESKTOP = styled.section`
@media screen and (max-width: 48rem) {
   display: none;
}
@media screen and (min-width: 48rem) {
    animation ${dimmer} 3s ease-in-out;
    position: fixed;
    background: transparent;
    width: 25%;
    padding: 0rem;
    margin: 0;
    top: 55%;
    right: 75%;
}
`
const PushCardMobileSIDE = styled.div`
@media screen and (min-width: 48rem) {
    display: none
}
position: fixed;
background: #020617eb;
right: 0;
padding: .3rem;
border-top-left-radius: 1rem;
border-bottom-left-radius: 1rem;
top: 60%;
z-index: 200;

& p {
    color: white
}
`
const PushCardDesktopSIDE = styled.div`
@media screen and (max-width: 48rem) {
    display: none
}
position: fixed;
background: #020617eb;
right: 0;
padding: .5rem;
border-top-left-radius: 1rem;
border-bottom-left-radius: 1rem;
top: 35%;
z-index: 20;
&:hover{ 
     cursor: pointer }

& p {
    color: white
}
`

const PushCards = ({dispatch, quo = []}) => {

    
    const[count, setcount] = useState(1)
    const[timerID, setID] = useState(null)
    const[myQuotes, setMQ] = useState([])
    const[show, setShow] = useState(false)
    const[deskShow, setDeskShow] = useState(false)

    useEffect(() => {
        if(quo.length < 1) {

            dispatch(getQuo())
        
        }
    }, [dispatch, quo])

    useEffect(() => {
        if(quo.length > 0){
            // console.log(quo[0][0])
         setMQ(quo)
        }
        else setMQ([])
    }, [quo])
      

    useEffect(() => {
        var interval = setInterval(() => setcount(count + 1), 30 * 1000)

        setID(interval)

         return () => clearInterval(interval)
    },[count])
  
if(count === myQuotes.length) {
    clearInterval(timerID)

} 

 
// useEffect(() => {
    
//     console.log(myQuotes[count - 1] !== undefined ? myQuotes[count - 1].quote : '')    
// },[count, myQuotes])
    
   return ( 
        <>
        <PUSHCARDMOBILE style={!show ? {transition:'2s ease-in-out', display:'none'} : {display:'block'}}>

  <QuoteCards whoRenders='pushCard' qRedux={ myQuotes[count - 1] !== undefined ? [ myQuotes[count - 1] ] : [] }  />  
        </PUSHCARDMOBILE>

        <PushCardMobileSIDE onClick={() =>{ setShow(!show);
        if(deskShow) setDeskShow(false)
        }} >
    <p>Quotes...</p>
        </PushCardMobileSIDE>

        <PushCardDesktopSIDE onClick={() => {setDeskShow(!deskShow);
        if(show) setShow(!show)
        }} >
    <p>Quotes...</p>
        </PushCardDesktopSIDE>

        <PUSHCARDDESKTOP style={!deskShow ? {transition:'2s ease-in-out', display:'none'} : {display:'block'}}>

  <QuoteCards whoRenders='pushCard' byRender='desk' qRedux={ myQuotes[count - 1] !== undefined ? [ myQuotes[count - 1] ] : [] } />  
        </PUSHCARDDESKTOP>

 
        </>
     
     );
}

const mapStateToProps = ({Quote}) => ({quo: Quote})
 
export default connect(mapStateToProps, null)(PushCards);